import React from "react";
import MasterLayout from "../../../../masterLayout/MasterLayout";
import Breadcrumb from "../../../../components/Breadcrumb";
import ManageProductLayer from "../../../components/Admin/ManageProductLayer";

const ManageProduct = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title='Add Category' />

        {/* BlankPageLayer */}
        <ManageProductLayer />
      </MasterLayout>
    </>
  );
};
export default ManageProduct